// src/data/sidebar_config.js

/**
 * Single source of truth for sidebar UI per role/app.
 * - role_key: normalized role name from user profile (lowercase, underscores)
 * - app_key: which portal/module is active (fund_manager, donor_portal, governance, entrepreneur)
 */

export const SIDEBAR_CONFIG = {
  fund_manager: {
    header_title: "Fund Manager",

    // ✅ Fund Manager menu (matches your latest design)
    menu: [
      {
        key: "social_impact_intelligence",
        label: "Social Impact Intelligence",
        icon: "bi bi-graph-up-arrow"
      },
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe" },
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" }
        ]
      },
      {
        key: "skills_development_youth_employment",
        label: "Skills Development & Youth Employment",
        icon: "bi bi-mortarboard",
        type: "section",
        children: [
          { key: "sdye_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sdye_social_impact", label: "Social Impact", icon: "bi bi-globe" },
          { key: "sdye_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
        ]
      },
      {
        key: "socio_economic_development",
        label: "Socio-Economic Development",
        icon: "bi bi-diagram-3",
        type: "section",
        children: [
          { key: "sed_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sed_social_impact", label: "Social Impact", icon: "bi bi-globe" },
          { key: "sed_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" }
        ]
      },
      {
        key: "employee_volunteerism_engagement",
        label: "Employee Volunteerism & Engagement",
        icon: "bi bi-people"
      },
      {
        key: "stakeholder_community_feedback",
        label: "Stakeholder & Community Feedback",
        icon: "bi bi-chat-dots"
      }
    ],

    include_programmes_component: false
  },

  donor_portal: {
    header_title: "Donor",
    menu: [
      {
        key: "social_impact_intelligence",
        label: "Social Impact Intelligence",
        icon: "bi bi-graph-up-arrow"
      },
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "skills_development_youth_employment",
        label: "Skills Development & Youth Employment",
        icon: "bi bi-mortarboard",
        type: "section",
        children: [
          { key: "sdye_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sdye_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sdye_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "socio_economic_development",
        label: "Socio-Economic Development",
        icon: "bi bi-diagram-3",
        type: "section",
        children: [
          { key: "sed_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sed_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sed_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "employee_volunteerism_engagement",
        label: "Employee Volunteerism & Engagement",
        icon: "bi bi-people"
      },
      {
        key: "stakeholder_community_feedback",
        label: "Stakeholder & Community Feedback",
        icon: "bi bi-chat-dots"
      }
    ],
    include_programmes_component: false
  },

  governance: {
    header_title: "Governance",
    menu: [
      {
        key: "social_impact_intelligence",
        label: "Social Impact Intelligence",
        icon: "bi bi-graph-up-arrow"
      },
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "skills_development_youth_employment",
        label: "Skills Development & Youth Employment",
        icon: "bi bi-mortarboard",
        type: "section",
        children: [
          { key: "sdye_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sdye_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sdye_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "socio_economic_development",
        label: "Socio-Economic Development",
        icon: "bi bi-diagram-3",
        type: "section",
        children: [
          { key: "sed_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sed_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sed_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "employee_volunteerism_engagement",
        label: "Employee Volunteerism & Engagement",
        icon: "bi bi-people"
      },
      {
        key: "stakeholder_community_feedback",
        label: "Stakeholder & Community Feedback",
        icon: "bi bi-chat-dots"
      }
    ],
    include_programmes_component: false
  },

  entrepreneur: {
    header_title: "Entrepreneur",
    menu: [
      {
        key: "social_impact_intelligence",
        label: "Social Impact Intelligence",
        icon: "bi bi-graph-up-arrow"
      },
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "skills_development_youth_employment",
        label: "Skills Development & Youth Employment",
        icon: "bi bi-mortarboard",
        type: "section",
        children: [
          { key: "sdye_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sdye_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sdye_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "socio_economic_development",
        label: "Socio-Economic Development",
        icon: "bi bi-diagram-3",
        type: "section",
        children: [
          { key: "sed_compliance", label: "Compliance", icon: "bi bi-file-earmark-check" },
          { key: "sed_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "sed_social_impact", label: "Social Impact", icon: "bi bi-globe" }
        ]
      },
      {
        key: "employee_volunteerism_engagement",
        label: "Employee Volunteerism & Engagement",
        icon: "bi bi-people"
      },
      {
        key: "stakeholder_community_feedback",
        label: "Stakeholder & Community Feedback",
        icon: "bi bi-chat-dots"
      }
    ],
    include_programmes_component: false
  }
};

/**
 * Map normalized role names to sidebar config keys.
 * Example: "Fund Manager" -> "fund_manager"
 */
export const ROLE_TO_APP_KEY = {
  admin: "fund_manager",
  system_admin: "fund_manager",
  root_user: "fund_manager",
  fund_manager: "fund_manager",
  donor: "donor_portal",
  governance: "governance",
  entrepreneur: "entrepreneur"
};
